import { render } from "./ConversationTranscript.vue?vue&type=template&id=4dd9064b"
import script from "./ConversationTranscript.vue?vue&type=script&lang=js"
export * from "./ConversationTranscript.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__